import(/* webpackMode: "eager" */ "/app/app/developer/page.tsx");
